// Angular
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	MatAutocompleteModule,
	MatButtonModule,
	MatCardModule,
	MatCheckboxModule,
	MatDatepickerModule,
	MatDialogModule,
	MatIconModule,
	MatInputModule,
	MatMenuModule,
	MatNativeDateModule,
	MatPaginatorModule,
	MatProgressBarModule,
	MatProgressSpinnerModule,
	MatRadioModule,
	MatSelectModule,
	MatSnackBarModule,
	MatSortModule,
	MatTableModule,
	MatToolbarModule,
	MatTabsModule,
	MatTooltipModule,
	MatExpansionModule,
	MatListModule,
	MatSidenavModule
} from '@angular/material';
// NgBootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// Perfect Scrollbar
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
// Core module
import { CoreModule } from '../../core/core.module';
// CRUD Partials
import { ActionNotificationComponent, AlertComponent, DeleteEntityDialogComponent, FetchEntityDialogComponent, UpdateStatusDialogComponent } from './content/crud';
import { DesignModule } from './design/design.module';
import { MatBadgeModule } from '@angular/material';

import { BaseAtylModule } from '../../base/base.module'


// Layout partials
import {
	ContextMenu2Component,
	ContextMenuComponent,
	LanguageSelectorComponent,
	NotificationComponent,
	QuickActionComponent,
	QuickPanelComponent,
	ScrollTopComponent,
	SearchDefaultComponent,
	SearchDropdownComponent,
	SearchResultComponent,
	SplashScreenComponent,
	StickyToolbarComponent,
	Subheader1Component,
	Subheader2Component,
	Subheader3Component,
	UserProfile2Component,
	UserProfileComponent,
	UserProfile3Component
} from './layout';
// General
import { NoticeComponent } from './content/general/notice/notice.component';
import { PortletModule } from './content/general/portlet/portlet.module';
// Errpr
import { ErrorComponent } from './content/general/error/error.component';
// Extra module
import { WidgetModule } from './content/widgets/widget.module';
// SVG inline
import { InlineSVGModule } from 'ng-inline-svg';
import { CartComponent } from './layout/topbar/cart/cart.component';

import { CourrierDialog } from './layout/dialog/courrier-dialog.component';
import { PrintDialog } from './layout/dialog/print-dialog.component';
import { StateDialogComponent } from './layout/dialog/state-dialog.component';
import { SaveFiltersDialog } from './layout/dialog/save-filters-dialog.component';
import { FormulaireDossierDialogComponent } from './layout/dialog/formulaire-dossier-dialog.component';
import { UploadFileDialogComponent } from './layout/dialog/upload-file-dialog.component';

import { DragDropDirective } from '../../motor-form-atyl/atyl-directive-components/drag-drop-directive';
import { NgxSummernoteModule } from 'ngx-summernote';
import { ConfirmComponent } from './layout/dialog/confirm.component';
import { AccesComponent } from './layout/dialog/acces.component';
import { ModifUserDialog } from './layout/dialog/modif-user-dialog/modif-user-dialog.component';
import { DoublonComponent } from './layout/dialog/doublon.component';
import { ChoiceCourrierComponent } from './layout/dialog/choice-courrier.component';
import { DossierAlerteComponent } from './layout/dossier-alerte/dossier-alerte.component';
import { RelationInformationComponent } from './layout/relation-information/relation-information.component';
import { EtapeinstructionComponent } from './layout/dialog/etapeinstruction.component';
import { FormulaireDossierRDVDialogComponent } from './layout/dialog/formulaire-dossier-rdv-dialog.component';
import { TransmettreDialogComponent } from './layout/dialog/transmettre-dialog.component';
import { PipesModule } from '../../pipes/pipes.module'
import { DemandeInstructionDialogComponent } from './layout/dialog/demande-instruction-dialog.component';

import { AdresseHistoriqueDialogComponent } from './layout/dialog/adresse/adresse-dialog.component';

import { InstructionHistoriqueDialog } from './layout/dialog/instruction-historique-dialog/instruction-historique-dialog.component';
import { TabGroupComponent } from './layout/tab-group/tab-group.component';
import { TabComponent } from './layout/tab-group/tab/tab.component';

import { CustomToolTipComponent } from './content/general/tooltip/custom-tool-tip.component';
import { ToolTipRendererDirective } from './content/general/tooltip/custom-tool-tip.directive';

import { InstructionListComponent } from './content/instruction/instruction-list/instruction-list.component';
import { InstructionTabsComponent } from './content/instruction/instruction-tabs/instruction-tabs.component';


import { FormulaireInformationComponent } from './layout/formulaire-information/formulaire-information.component';

import { AtylTextBannerComponent } from './content/general/text-banner/text-banner.component';

import { MessageComponent } from './content/message/message.component'
import { MessageDialogComponent } from './content/message/dialog/message-dialog.component'
import { MessageInfoComponent } from './layout/dialog/message-info-dialog/message-info.component'

import { GroupeComponent } from './content/groupe/groupe.component'
import { GroupeDialogComponent } from './content/groupe/dialog/groupe-dialog.component'
import { GroupeListComponent } from './content/groupe/list/list.component'
import { SearchComponent } from './content/general/search/search.component'

@NgModule({
	declarations: [
		ScrollTopComponent,
		NoticeComponent,
		ActionNotificationComponent,
		DeleteEntityDialogComponent,
		FetchEntityDialogComponent,
		UpdateStatusDialogComponent,
		AlertComponent,
        ModifUserDialog,
		// topbar components
		ContextMenu2Component,
		ContextMenuComponent,
		QuickPanelComponent,
		ScrollTopComponent,
		SearchResultComponent,
		SplashScreenComponent,
		StickyToolbarComponent,
		Subheader1Component,
		Subheader2Component,
		Subheader3Component,
		LanguageSelectorComponent,
		NotificationComponent,
		QuickActionComponent,
		SearchDefaultComponent,
		SearchDropdownComponent,
		UserProfileComponent,
		UserProfile2Component,
		UserProfile3Component,
		CartComponent,

		ErrorComponent,
		CourrierDialog,
		ChoiceCourrierComponent,
		PrintDialog,
		StateDialogComponent,
		UploadFileDialogComponent,
		SaveFiltersDialog,
		FormulaireDossierDialogComponent,
		DragDropDirective,
		ConfirmComponent,
		AccesComponent,
		InstructionHistoriqueDialog,
		DoublonComponent,
		ChoiceCourrierComponent,
		DossierAlerteComponent,
		RelationInformationComponent,
		EtapeinstructionComponent,
		FormulaireDossierRDVDialogComponent,
		TransmettreDialogComponent,
		DemandeInstructionDialogComponent,
		AdresseHistoriqueDialogComponent,
        TabGroupComponent,
        TabComponent,
        CustomToolTipComponent,
        ToolTipRendererDirective,
		InstructionListComponent,
		InstructionTabsComponent,
		FormulaireInformationComponent,
		AtylTextBannerComponent,
		MessageComponent,
		MessageDialogComponent,
		MessageInfoComponent,
		GroupeComponent,
		GroupeDialogComponent,
		GroupeListComponent,
		SearchComponent		
	],
	exports: [
		WidgetModule,
		PortletModule,

		ScrollTopComponent,
		NoticeComponent,
		ActionNotificationComponent,
		DeleteEntityDialogComponent,
		FetchEntityDialogComponent,
		UpdateStatusDialogComponent,
		AlertComponent,

		// topbar components
		ContextMenu2Component,
		ContextMenuComponent,
		QuickPanelComponent,
		ScrollTopComponent,
		SearchResultComponent,
		SplashScreenComponent,
		StickyToolbarComponent,
		Subheader1Component,
		Subheader2Component,
		Subheader3Component,
		LanguageSelectorComponent,
		NotificationComponent,
		QuickActionComponent,
		SearchDefaultComponent,
		SearchDropdownComponent,
		UserProfileComponent,
		UserProfile2Component,
		UserProfile3Component,
		CartComponent,
        ModifUserDialog,
		ErrorComponent,
		CourrierDialog,
		PrintDialog,
		StateDialogComponent,
		UploadFileDialogComponent,
		SaveFiltersDialog,
		DossierAlerteComponent,
		RelationInformationComponent,
        TabGroupComponent,
        TabComponent,
		InstructionListComponent,
		InstructionTabsComponent,
		CustomToolTipComponent,
		ToolTipRendererDirective,
		FormulaireInformationComponent,
		AtylTextBannerComponent,
		MessageComponent,
		GroupeComponent,
		GroupeListComponent,
		SearchComponent
				
	],
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule,
		PerfectScrollbarModule,
		InlineSVGModule,
		CoreModule,
		PortletModule,
		WidgetModule,
		MatSidenavModule,
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
		MatInputModule,
		MatTableModule,
		MatToolbarModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatIconModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatTabsModule,
		MatTooltipModule,
		MatDialogModule,
		MatExpansionModule,
		MatListModule,
		NgxSummernoteModule,
		PipesModule,
        DesignModule,
		MatBadgeModule,
		BaseAtylModule
	],
	providers: [
	],
	entryComponents: [
		CourrierDialog,
		ChoiceCourrierComponent,
		PrintDialog,
        ModifUserDialog,
		StateDialogComponent,
		SaveFiltersDialog,
		UploadFileDialogComponent,
		FormulaireDossierDialogComponent,
		ConfirmComponent,
		AccesComponent,
		InstructionHistoriqueDialog,
		DoublonComponent,
		EtapeinstructionComponent,
		FormulaireDossierRDVDialogComponent,
		TransmettreDialogComponent,
		DemandeInstructionDialogComponent,
		AdresseHistoriqueDialogComponent,
		CustomToolTipComponent,
		InstructionListComponent,
		InstructionTabsComponent,
		AtylTextBannerComponent,
		MessageDialogComponent,
		MessageInfoComponent,
		GroupeDialogComponent,
	]
})
export class PartialsModule {
}
